"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userGroups = exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/customer/userGroups");
const _usergroupListReducer = require("../../modules/usergroup/list/reducers");
const _usergroupInviteReducer = require("../../modules/usergroup/invite/reducers");
const usergroupListReducer = _usergroupListReducer.default('customer/user-groups');
const usergroupInviteReducer = _usergroupInviteReducer.default('customer/user-groups');
const createEditInitialState = {
    mode: 'NONE',
    type: 'NONE',
    status: 'STANDBY',
    editGroup: undefined
};
exports.initialState = Object.assign(Object.assign({}, usergroupListReducer.initialState), { invite: Object.assign({}, usergroupInviteReducer.initialState), moveUserModal: false, moveUserStatus: 'STANDBY', removeUserStatus: 'STANDBY', removeGroupStatus: 'STANDBY', createEdit: Object.assign({}, createEditInitialState) });
//#endregion
//#region LENS
const inviteLens = monocle.Lens.fromProp('invite');
const moveUserModalLens = monocle.Lens.fromProp('moveUserModal');
const moveUserStatusLens = monocle.Lens.fromProp('moveUserStatus');
const removeUserStatusLens = monocle.Lens.fromProp('removeUserStatus');
const removeGroupStatusLens = monocle.Lens.fromProp('removeGroupStatus');
const createEditLens = monocle.Lens.fromProp('createEdit');
const selectedUsersLens = monocle.Lens.fromProp('selectedUsers');
const selectedGroupsLens = monocle.Lens.fromProp('selectedGroups');
const methods = Object.assign({}, usergroupListReducer.methods);
exports.methods = methods;
methods[Actions.CLEAR_STATE] = () => (Object.assign({}, exports.initialState));
// Create new user group
methods[Actions.CREATE_EDIT_GROUP_MODAL] = (state, action) => {
    return createEditLens.set({
        mode: action.payload.mode,
        type: action.payload.type,
        status: 'STANDBY',
        editGroup: action.payload.group
    })(state);
};
methods[Actions.CREATE_EDIT_REQUEST] = (state) => createEditLens.modify((x) => (Object.assign(Object.assign({}, x), { status: 'SAVING' })))(state);
methods[Actions.CREATE_EDIT_SUCCESS] = (state) => createEditLens.modify((x) => (Object.assign({}, createEditInitialState)))(state);
methods[Actions.CREATE_EDIT_FAILED] = (state) => createEditLens.modify((x) => (Object.assign(Object.assign({}, x), { status: 'FAILED' })))(state);
// Remove group
methods[Actions.REMOVE_GROUP_REQUEST] = (state) => removeGroupStatusLens.set('FETCHING')(state);
methods[Actions.REMOVE_GROUP_SUCCESS] = (state) => fp.function.compose(removeGroupStatusLens.set('FETCHED'), selectedGroupsLens.set([]))(state);
methods[Actions.REMOVE_GROUP_FAILED] = (state) => removeGroupStatusLens.set('FAILED')(state);
// Remove user
methods[Actions.REMOVE_USER_REQUEST] = (state) => removeUserStatusLens.set('FETCHING')(state);
methods[Actions.REMOVE_USER_SUCCESS] = (state) => fp.function.compose(removeUserStatusLens.set('FETCHED'), selectedUsersLens.set([]))(state);
methods[Actions.REMOVE_USER_FAILED] = (state) => removeUserStatusLens.set('FAILED')(state);
// Move user
methods[Actions.TOGGLE_MOVE_USER_MODAL] = (state) => moveUserModalLens.modify((x) => !x)(state);
methods[Actions.MOVE_USER_REQUEST] = (state) => moveUserStatusLens.set('FETCHING')(state);
methods[Actions.MOVE_USER_SUCCESS] = (state) => fp.function.compose(moveUserStatusLens.set('FETCHED'), selectedUsersLens.set([]))(state);
methods[Actions.MOVE_USER_FAILED] = (state) => moveUserStatusLens.set('FAILED')(state);
//#endregion
const handleInvite = (action) => (state) => {
    const fn = usergroupInviteReducer.methods[action.type];
    if (fn) {
        return inviteLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleState = (action) => (state) => {
    const fn = methods[action.type];
    if (fn) {
        return fn(state, action);
    }
    return state;
};
function userGroups(state, action) {
    return fp.function.compose(handleInvite(action), handleState(action))(state);
}
exports.userGroups = userGroups;
//# sourceMappingURL=userGroups.js.map